import { Observable } from 'rxjs';
import { Product } from '@spartacus/core';

export abstract class GgProductHighlightsAdapter {
  abstract getProduct(productCode: string, retailerActionCode: string): Observable<Product>;
}
